import consentDispatcher from '../action';

const initialState = {
  list: [],
  paging: {
    pageIndex: 0,
    pageSize: 10,
    totalItem: 0,
    totalPage: 0
  }
};

const consentReducer = consentDispatcher(initialState, {
  [consentDispatcher.getDataSuccess]: (state, payload) => ({
    list: payload.data.list,
    paging: {
      ...payload.data,
      list: undefined
    }
  }),
  [consentDispatcher.setState]: (state, payload) => ({
    [payload.state]: payload.value
  })
});

export default consentReducer;
